module.exports = __webpack_public_path__ + "media/message.e4ee8368.mp3";